import React from 'react';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import SEO from '@/components/SEO';

const RefundPolicyPage = () => {
    return (
        <div className="min-h-screen bg-slate-50">
            <SEO
                title="Refund Policy"
                description="Read our refund and cancellation policy. Understand the terms and conditions for booking with Peregrine Tours & Safaris."
                keywords="Refund Policy, Cancellation Policy, Safari Terms, Travel Conditions"
                canonicalUrl="https://www.peregrinetoursandsafaris.com/refund-policy"
            />
            <Navbar />
            <main className="container-custom pt-32 pb-20">
                <div className="max-w-3xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-100">
                    <h1 className="text-3xl md:text-4xl font-bold font-serif mb-8 text-foreground">Refund and Cancellation Policy</h1>

                    <div className="space-y-8 text-slate-600 leading-relaxed">
                        <section>
                            <h2 className="text-xl font-bold text-foreground mb-4">Cancellation Policy</h2>
                            <p>
                                At Peregrine Tours & Safaris, we understand that plans can change. We have structured our cancellation policy to be as fair as possible while accounting for the preparations involved in delivering our safaris and activities.
                            </p>
                        </section>

                        <div className="bg-blue-50 border-l-4 border-primary p-6 rounded-r-lg">
                            <h3 className="text-lg font-bold text-blue-900 mb-2">Full Refund Eligibility</h3>
                            <p className="text-blue-800">
                                Cancellations made <strong>24 to 48 hours prior</strong> to the scheduled booking date are eligible for a <strong>100% full refund</strong>.
                            </p>
                        </div>

                        <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-lg">
                            <h3 className="text-lg font-bold text-amber-900 mb-2">Partial Refund / Late Cancellations</h3>
                            <p className="text-amber-800">
                                Cancellations made <strong>on the booked date</strong> or <strong>less than 24 hours</strong> prior to the activity will be subject to a partial refund or forfeiture, depending on the specific activity costs incurred by us.
                            </p>
                        </div>

                        <section>
                            <h2 className="text-xl font-bold text-foreground mb-4">How to Request a Refund</h2>
                            <p className="mb-4">
                                To initiate a cancellation and request a refund, please contact our support team immediately.
                            </p>
                            <ul className="list-disc pl-5 space-y-2">
                                <li><strong>Email:</strong> <a href="mailto:info@peregrinetoursandsafaris.com" className="text-primary hover:underline">info@peregrinetoursandsafaris.com</a></li>
                                <li><strong>Phone:</strong> +260 97 7891263</li>
                            </ul>
                            <p className="mt-4">
                                Please include your Booking Reference Number and the reason for cancellation in your communication. Refunds are processed within 7-10 business days to the original method of payment.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-foreground mb-4">Rescheduling</h2>
                            <p>
                                If you wish to simply change the date of your activity rather than cancel, please contact us at least 24 hours in advance. We will do our best to accommodate your new preferred date without any penalty, subject to availability.
                            </p>
                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default RefundPolicyPage;
